import { CSSProperties, FC, ReactElement } from 'react';

import './HorizontalScroll.scss';

interface HorizontalScrollProps {
  items: ReactElement[];
  style?: CSSProperties;
}
export const HorizontalScroll: FC<HorizontalScrollProps> = ({ items, style }) => {
  return (
    <div className={`horizontal-scroll item-count-${items.length}`} style={style}>
      <div className="horizontal-scroll-inner">
        {items.map((item, i) => (
          <div key={item.key ?? i} className="horizontal-scroll-item">
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
